import React from "react";

export const Change: React.FunctionComponent = () => (
	<section>
		<h1>Új e-mail értesítés</h1>
		<p>
			A jövőben automatikus e-mail értesítések kerülnek kiküldésre a
			pácienshez kapcsolt felhasználóknak, amennyiben a páciens
			státuszában változás történik.
		</p>
	</section>
);
